<!--
 Program: TransPopup.vue
 Author: SKP
 Description: translation screen(by U Trans)
-->
<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size md_size">
            <a href="javascript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis">
                    <i>{{ title }}</i>
                </dt>
                <dd>
                    <div class="translation_wrap">
                        <dl class="dl_select">
                            <dd data-input-type="select">
                                <select class="slt_none w100p" v-model="transParam.source.language" @change="changeSourceLang">
                                    <option
                                        :value="sourceCode.code"
                                        v-for="sourceCode in transParam.source.langList"
                                        :key="sourceCode.codeId"
                                    >{{ sourceCode.text }}</option>
                                    <!-- Mixin SDLLocale.js > getLabel() -->
                                </select>
                            </dd>
                            <!-- Language change -->
                            <dd class="icon" @click="setLanguageChange">
                                <em class="ico_translate">
                                    <span class="sr_only">ico_translate</span>
                                </em>
                            </dd>
                            <dd data-input-type="select">
                                <select class="slt_none w100p" v-model="transParam.target.language">
                                    <option
                                        :value="targetCode.code"
                                        v-for="targetCode in transParam.target.langList"
                                        :key="targetCode.codeId"
                                    >{{ targetCode.text }}</option>
                                    <!-- Mixin SDLLocale.js > getLabel() -->
                                </select>
                            </dd>
                            <dd class="btn">
                                <a href="javascript:" class="btn_blue" @click="getTranslation">{{ $t('BUTTON.GLOBAL.TRANSLATE') }}</a>
                                <a href="javascript:" class="btn_white" @click.stop.prevent="copyText">{{ $t('BUTTON.GLOBAL.COPY') }}</a>
                            </dd>
                        </dl>
                    </div>

                    <dl class="trans_write_wrap">
                        <dd data-input-type="textarea">
                            <textarea
                                class="textarea_ty w100p scroll"
                                rows="15"
                                maxlength="5000"
                                placeholder=""
                                v-model="transParam.source.text"
                            ></textarea>
                            <!-- TODO return language count 구현 필요 -->
                            <span class="textarea_counter">{{ getTextLength }} / 5000</span>
                        </dd>
                        <dd data-input-type="textarea">
                            <textarea
                                id="targetText"
                                class="textarea_ty w100p"
                                rows="15"
                                placeholder=""
                                v-model="transParam.target.text"
                            ></textarea>
                        </dd>
                    </dl>

                    <div class="tooltip_wrap fl_right">
                        <small class="text-muted">
                            <em class="txt_mandatory">*</em>
                            Powered by UTrans (<a href="mailto:utrans@samsung.com" target="_top">utrans@samsung.com</a>)
                        </small>
                    </div>

                </dd>
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue          from 'vue';
import qs           from 'query-string';
import axios        from 'axios';
import _            from 'lodash';
import store        from '@/vuex/store';
import SDLUtil      from '@/utils/SDLUtil';
import SDLLocale    from '@/mixin/SDLLocale';
import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        bodyText : {}
    },
    data() {
        return {
            title: 'Translation',
            transParam: {
                source: {
                    language: 'en',
                    text: this.bodyText || '',
                    langList: [],
                },
                target: {
                    language: 'en',
                    text: '',
                    langList: [],
                },
            },
            baseLangList: [
                { codeId: 'ko', code: 'ko', text: 'Korean' },
                { codeId: 'en', code: 'en', text: 'English' },
                { codeId: 'ja', code: 'ja', text: 'Japanese' },
                { codeId: 'zh', code: 'zh', text: 'Chinese' },
                { codeId: 'es', code: 'es', text: 'Spanish' },
                { codeId: 'ru', code: 'ru', text: 'Russian' },
                { codeId: 'vi', code: 'vi', text: 'Vietnamese' },
                { codeId: 'de', code: 'de', text: 'German' },
                { codeId: 'fr', code: 'fr', text: 'French' },
                { codeId: 'it', code: 'it', text: 'Italian' },
                { codeId: 'pt', code: 'pt', text: 'Portuguese' }
            ],
            translateText: '',
            completeTrans: false,
        };
    },
    computed: {
        ...mapGetters({
            getLocale: 'getLocale',
        }),
        getTextLength() {
            let text = this.transParam.source.text;
            if(SDLUtil.isNull(text)) {
                return 0;

            } else {
                if(text.length > 5000) {
                    this.transParam.source.text = text.substring(1, 5000);
                }
            }

            return SDLUtil.textLength(this.transParam.source.text);
        },
        getTargetLocale() {
            let localeMap = this.baseLangList.map(function(l) { return l.codeId; }),
                locale = this.getLocale || 'en';

            if(localeMap.includes(locale)) {
                return 'en' === locale ? 'ko' : locale; 

            } else {
                return 'ko';
            }
        }
    },
    mixins: [SDLLocale],
    methods: {
        /**
         * param: nothing
         * return: nothing
         * exception: nothing
         * description: Set the target language combo when the source language combo changes
         */
        changeSourceLang() {
            const sourceLang = this.transParam.source.language === '' ? 'en' : this.transParam.source.language;
            const targetLang = this.transParam.target.language === '' ? 'ko' : this.transParam.target.language;

            let exclusionLang = [];

            /**
             * Branch to match supported translation directions
             */
            if (sourceLang !== 'ko') {
                if (sourceLang === 'vi' || sourceLang === 'ja') {
                    exclusionLang = this.baseLangList.filter(codeObj => codeObj.code !== 'ko').map(code => code.code);
                } else {
                    exclusionLang.push('ja');
                    exclusionLang.push('vi');
                }
            }

            // Exclude settings if the source select box value is specified in the exclusion array
            if (!_.includes(exclusionLang, sourceLang)) {
                exclusionLang.push(sourceLang);
            }

            const tempCodeList = this.baseLangList.slice();

            /**
             * Exclude excluded language codes from the default language code
             */
            exclusionLang.forEach(lang => {
                tempCodeList.splice(_.findIndex(tempCodeList, codeObj => codeObj.code === lang), 1);
            });

            // Set target select box
            this.transParam.target.langList = tempCodeList;

            // Specify the default selection value
            if (targetLang && this.transParam.target.langList.findIndex(codeObj => codeObj.code === targetLang) > -1) {
                this.transParam.target.language = targetLang;
            } else {
                this.transParam.target.language = this.transParam.target.langList[0].code;
            }
        },
        /**
         * param: nothing
         * return: nothing
         * exception: nothing
         * description: language conversion(source <-> target)
         */
        setLanguageChange() {
            const sourceLang = this.transParam.source.language;
            const sourceText = this.transParam.source.text;

            // language(source <-> target)
            this.transParam.source.language = this.transParam.target.language;
            this.transParam.target.language = sourceLang;

            // target selectbox setting
            this.changeSourceLang();

            // textarea(source <-> target)
            this.transParam.source.text = this.transParam.target.text;
            this.transParam.target.text = sourceText;
        },
        /**
         * param: nothing
         * return: nothing
         * exception: nothing
         * description: textarea initialization
         */
        textClear() {
            this.transParam.source.text = '';
            this.transParam.target.text = '';
        },
        /**
         * param: nothing
         * return: nothing
         * exception: nothing
         * description: Execute the translation api execution function
         */
        getTranslation() {
            const inputText = this.transParam.source.text;

            // If there is no translation character, initialize API call X and translation result value
            if (inputText.length === 0) {
                this.transParam.target.text = inputText;
                return;
            }

            const inputTextArray = inputText.split('\n');

            if (inputTextArray.length > 0) {
                // Launch Loading bar
                SDLUtil.showLoadingBar(true);

                Promise.all(inputTextArray.map(this.callTranslateApi))
                    .then(data => {
                        Vue.$log.info(data);
                        // init target textarea
                        this.transParam.target.text = '';

                        data.some(result => {
                            if (_.isEmpty(result.errorCode) || result.errorCode === '' || result.errorCode === '1111') {
                                this.transParam.target.text = `${this.transParam.target.text}${result.result}\n`;
                            } else if (result.errorCode === '2001') {
                                this.transParam.target.text = `${this.transParam.target.text}\n`;
                            } else if (result.errorCode === '2002') {
                                SDLUtil.alert('MESSAGE.TRANS.INPUTCHAREXCEEDED');
                                return true;
                            }
                        });

                        // Remove Loading bar
                        SDLUtil.showLoadingBar(false);
                    })
                    .catch(err => {
                        // Remove Loading bar
                        SDLUtil.showLoadingBar(false);
                        // Call error alert
                        SDLUtil.errorAlert(err);
                    });
            }
        },
        /**
         * param: nothing
         * return: nothing
         * exception: nothing
         * description: Close
         */
        close() {
            this.$emit('close');
        },
        /**
         * param: string
         * return: nothing
         * exception: Call error alert
         * description: Calling the Translation API
         */
        callTranslateApi(query) {
            return new Promise((resolve, reject) => {
                /**
                 * Calling the Translation API
                 */
                axios
                    .post(
                        `${SDLUtil.API_URL}/basis/common/translate.skp`,
                        qs.stringify(
                            {
                                source: this.transParam.source.language,
                                target: this.transParam.target.language,
                                query,
                            }
                        ),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },
        /**
         * param: nothing
         * return: nothing
         * exception: Call error alert
         * description: Copy translated sentences to the clipboard
         */
        copyText() {
            const targetText = document.querySelector('#targetText');
            targetText.setAttribute('type', 'text');
            targetText.select();

            try {
                const successful = document.execCommand('copy');
                const msg = successful ? 'successful' : 'unsuccessful';
                SDLUtil.alert({ title: 'BUTTON.GLOBAL.CONFIRM', msg: 'MESSAGE.TRANS.COPY' });
                Vue.$log.info(msg);
            } catch (err) {
                SDLUtil.errorAlert(err);
                Vue.$log.info('copy error');
            }

            /* unselect the range */
            targetText.setAttribute('type', 'hidden');
            window.getSelection().removeAllRanges();
        },
    },
    created() {
        this.transParam.source.langList = this.baseLangList.slice();
        this.transParam.target.langList = this.baseLangList.slice();

        this.transParam.target.language = this.getTargetLocale;

        this.changeSourceLang();
    },
};
</script>
<style>
.modal {
    display: block;
}
.text-muted { color: #6c757d!important; }
</style>



// WEBPACK FOOTER //
// src/skpComponents/common/popup/TransPopup.vue